// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { PatientModel } from '../_models/patient.model';

export enum PatientActionTypes {
  PatientOnServerCreated = '[Edit Patient Dialog] Patient On Server Created',
  PatientCreated = '[Edit Patient Dialog] Patient Created',
  PatientOnServerUpdated = '[Edit Patient Dialog] Patient On Server Updated',
  PatientUpdated = '[Edit Patient Dialog] Patient Updated',
  PatientStatusOnServerUpdated = '[Patient List Page] Patient Status On Server Updated',
  PatientStatusUpdated = '[Patient List Page] Patient Status Updated',
  PatientsStatusOnServerUpdated = '[Patient List Page] Patients Status On Server Updated',
  PatientsStatusUpdated = '[Patient List Page] Patients Status Updated',
  OnePatientOnServerDeleted = '[Patients List Page] One Patient On Server Deleted',
  OnePatientDeleted = '[Patients List Page] One Patient Deleted',
  ManyPatientsOnServerDeleted = '[Patients List Page] Many Patients On Server Deleted',
  ManyPatientsDeleted = '[Patients List Page] Many Patients Deleted',
  PatientsPageRequested = '[Patients List Page] Patients Page Requested',
  PatientsPageLoaded = '[Patients API] Patients Page Loaded',
  PatientsPageCancelled = '[Patients API] Patients Page Cancelled',
  PatientsPageToggleLoading = '[Patients] Patients Page Toggle Loading',
  PatientActionToggleLoading = '[Patients] Patients Action Toggle Loading',
  ThrowPatientError = '[Patients] Throw Patient Error',
  ClearPatientErrors = '[Patients] Clear Patient Errors',
  FirePatientSuccess = '[Patients] Fire Success',
}

export class PatientOnServerCreated implements Action {
  readonly type = PatientActionTypes.PatientOnServerCreated;
  constructor(public payload: { patient: PatientModel }) {}
}

export class PatientCreated implements Action {
  readonly type = PatientActionTypes.PatientCreated;

  constructor(public payload: { patient: PatientModel }) {}
}

export class PatientOnServerUpdated implements Action {
  readonly type = PatientActionTypes.PatientOnServerUpdated;

  constructor(
    public payload: {
      partialPatient: Update<PatientModel>; // For State update
      patient: PatientModel; // For Server update (through service)
    },
  ) {}
}

export class PatientUpdated implements Action {
  readonly type = PatientActionTypes.PatientUpdated;

  constructor(
    public payload: {
      partialPatient: Update<PatientModel>; // For State update
      patient: PatientModel; // For Server update (through service)
    },
  ) {}
}

export class PatientStatusOnServerUpdated implements Action {
  readonly type = PatientActionTypes.PatientStatusOnServerUpdated;

  constructor(
    public payload: {
      patient: PatientModel;
      id: number;
      is_active: boolean;
    },
  ) {}
}

export class PatientStatusUpdated implements Action {
  readonly type = PatientActionTypes.PatientStatusUpdated;

  constructor(
    public payload: {
      patient: PatientModel;
      id: number;
      is_active: boolean;
    },
  ) {}
}

export class PatientsStatusOnServerUpdated implements Action {
  readonly type = PatientActionTypes.PatientsStatusOnServerUpdated;

  constructor(
    public payload: {
      patients: PatientModel[];
      ids: number[];
      is_active: boolean;
    },
  ) {}
}

export class PatientsStatusUpdated implements Action {
  readonly type = PatientActionTypes.PatientsStatusUpdated;

  constructor(
    public payload: {
      patients: PatientModel[];
      ids: number[];
      is_active: boolean;
    },
  ) {}
}

export class OnePatientOnServerDeleted implements Action {
  readonly type = PatientActionTypes.OnePatientOnServerDeleted;

  constructor(public payload: { id: number }) {}
}

export class OnePatientDeleted implements Action {
  readonly type = PatientActionTypes.OnePatientDeleted;

  constructor(public payload: { id: number }) {}
}

export class ManyPatientsOnServerDeleted implements Action {
  readonly type = PatientActionTypes.ManyPatientsOnServerDeleted;

  constructor(public payload: { ids: number[] }) {}
}

export class ManyPatientsDeleted implements Action {
  readonly type = PatientActionTypes.ManyPatientsDeleted;

  constructor(public payload: { ids: number[] }) {}
}

export class PatientsPageRequested implements Action {
  readonly type = PatientActionTypes.PatientsPageRequested;

  constructor(public payload: { page: QueryParamsModel }) {}
}

export class PatientsPageLoaded implements Action {
  readonly type = PatientActionTypes.PatientsPageLoaded;

  constructor(
    public payload: { patients: PatientModel[]; totalCount: number; page: QueryParamsModel },
  ) {}
}

export class PatientsPageCancelled implements Action {
  readonly type = PatientActionTypes.PatientsPageCancelled;
}

export class PatientsPageToggleLoading implements Action {
  readonly type = PatientActionTypes.PatientsPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class PatientActionToggleLoading implements Action {
  readonly type = PatientActionTypes.PatientActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class ThrowPatientError implements Action {
  readonly type = PatientActionTypes.ThrowPatientError;

  constructor(public payload: { error: any }) {}
}

export class ClearPatientErrors implements Action {
  readonly type = PatientActionTypes.ClearPatientErrors;
}

export class FirePatientSuccess implements Action {
  readonly type = PatientActionTypes.FirePatientSuccess;
  constructor(public payload: { action_type: string }) {}
}

export type PatientActions =
  | PatientOnServerCreated
  | PatientCreated
  | PatientOnServerUpdated
  | PatientUpdated
  | PatientStatusOnServerUpdated
  | PatientStatusUpdated
  | PatientsStatusOnServerUpdated
  | PatientsStatusUpdated
  | OnePatientOnServerDeleted
  | OnePatientDeleted
  | ManyPatientsOnServerDeleted
  | ManyPatientsDeleted
  | PatientsPageRequested
  | PatientsPageLoaded
  | PatientsPageCancelled
  | PatientsPageToggleLoading
  | PatientActionToggleLoading
  | ThrowPatientError
  | ClearPatientErrors
  | FirePatientSuccess;
